import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CustomDateRangePicker from '../custom-date-range-picker/customDateRangePicker';
import uuid from 'uuid/v1';
import classes from './styles.module.css';
import { Button, IconButton } from '@material-ui/core';
import { useStyles } from '../form-action-buttons/styles';
import CloseIcon from '@material-ui/icons/Close';
import { getRange } from '../../utils/book-accommodation/availableDates';
import ConfirmContext from '../../contexts/ConfirmContext';
import moment from 'moment';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Label = styled.label`
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;

  letter-spacing: 0.0165em;
  text-transform: uppercase;

  color: #071b27;
`;

const Section = styled.div`
  width: 100%;

  gap: 12px;
  row-gap: 2px;

  display: flex;
  align-items: center;
  flex-wrap: wrap;

  padding: 0 4px 6px;
  margin-top: 6px;

  background: #ffffff;

  border: 1px solid #beceda;
  border-radius: 3px;
`;

const DatePickerWrapper = styled.div`
  position: relative;
 
`;

const CloseIconWrapper = styled.div`
  z-index: 1;
  position: absolute;
  top: calc(50% + 3px);
  right: 2px;
  transform: translateY(-50%);
`;

const DeactivateDatesInput = ({
  input: { value, onChange },
  label,
  bookDates
}) => {
  const buttonClasses = useStyles();
  const confirm = React.useContext(ConfirmContext);

  const [renderDates, setRenderedDates] = useState([]);

  useEffect(() => {
    setRenderedDates(
      Array.isArray(value) && value?.length
        ? value
        : [{ id: 'new-one' + uuid(10) }]
    );
  }, [value]);

  const handleChangeDate = id => newDate => {
    onChange(
      renderDates.map(date => (id === date.id ? { ...date, ...newDate } : date))
    );
  };

  const handleAddDateRange = () => {
    onChange([...renderDates, { id: 'new-one' + uuid(10) }]);
  };

  const handleDeleteDateRange = ({ id, startDate, endDate }) => () => {
    confirm({
      title: 'Delete deactivation Date?',
      description:
        startDate && endDate
          ? `${startDate &&
              moment(startDate).format('MMMM DD, YYYY')} - ${endDate &&
              moment(endDate).format('MMMM DD, YYYY')}`
          : undefined,
      cancellationText: 'Back',
      confirmationText: 'Delete'
    })
      .then(() => {
        onChange(
          renderDates.map(date =>
            date.id === id ? { ...date, isCanceled: true } : date
          )
        );
      })
      .catch(() => {});
  };

  const getDisabledRanges = currentId =>
    renderDates
      ?.reduce((acc, { id, startDate, endDate, isCanceled }) => {
        if (startDate && endDate && !isCanceled && id !== currentId) {
          return [
            ...acc,
            ...getRange(startDate, moment(endDate)).map(date => ({
              date
            }))
          ];
        }

        return acc;
      }, [])
      .concat(
        bookDates?.filter(({ deactivationBooking }) => !deactivationBooking) ||
          []
      );

  const activeDates = renderDates.filter(({ isCanceled }) => !isCanceled);

  return (
    <Wrapper>
      <Label>{label}</Label>

      <Section>
        {activeDates.map(({ id, ...dateValue }) => (
          <DatePickerWrapper key={id}>
            <CustomDateRangePicker
              id={id}
              input={{ value: dateValue, onChange: handleChangeDate(id) }}
              meta={{ touched: true, error: false, submitFailed: false }}
              accomodationDialog
              containerClassName={classes.containerClassName}
              className={classes.wrapperClassName}
              inputClassName={classes.inputStyles}
              disabledDates={getDisabledRanges(id)}
            />

            <CloseIconWrapper>
              <IconButton
                style={{ padding: 4 }}
                onClick={handleDeleteDateRange({ id, ...dateValue })}
              >
                <CloseIcon />
              </IconButton>
            </CloseIconWrapper>
          </DatePickerWrapper>
        ))}

        <Button
          variant="outlined"
          classes={{
            root: buttonClasses.cancelBtnRoot,
            disabled: buttonClasses.cancelBtnDisabled
          }}
          disabled={activeDates.length >= 10}
          onClick={handleAddDateRange}
          style={{ marginTop: 5 }}
        >
          Add
        </Button>
      </Section>
    </Wrapper>
  );
};

export default DeactivateDatesInput;
